module.exports = __webpack_public_path__ + "img/album23_12.c09d00ec.jpg";